shadow$provide[102] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Bootstrap:{enumerable:true, get:function() {
  return Bootstrap;
}}});
var require$_DOT__SLASH_api = require("./api");
var require$_DOT__SLASH_binder = require("./binder");
function isString(str) {
  return str && typeof str.valueOf() === "string";
}
const each = (array, cb) => {
  let i = 0;
  for (const item of array) {
    const success = cb(item, i, array);
    if (success === false) {
      break;
    }
    i++;
  }
};
class Bootstrap {
  static initClass() {
    this.Plugins = {};
    this.Aliases = {};
  }
  static registerPlugin(name, spec) {
    const ctor = function(options) {
      Bootstrap.Plugin.call(this, options);
      this.__name = name;
    };
    ctor.prototype = Object.assign(new Bootstrap.Plugin(), spec);
    this.Plugins[name] = ctor;
  }
  static unregisterPlugin(name) {
    delete this.Plugins[name];
  }
  static registerAlias(name, plugins) {
    this.Aliases[name] = plugins;
  }
  static unregisterAlias(name) {
    delete this.Aliases[name];
  }
  constructor(options) {
    if (options) {
      let args = [].slice.apply(arguments);
      options = {};
      if (args[0] instanceof Node) {
        const node = args[0];
        args = args.slice(1);
        options.element = node;
      }
      if (isString(args[0])) {
        options.plugins = args;
      } else if (Array.isArray(args[0])) {
        options.plugins = args[0];
      } else if (args[0]) {
        options = Object.assign({}, args[0], options);
      }
    }
    const defaultOpts = {init:true, element:document.body, plugins:["core"], aliases:{}, plugindb:Bootstrap.Plugins || {}, aliasdb:Bootstrap.Aliases || {},};
    this.__options = Object.assign({}, defaultOpts, options || {});
    this.__inited = false;
    this.__destroyed = false;
    this.__installed = [];
    let element = this.__options.element;
    if (element === "" + element) {
      element = document.querySelector(element);
    }
    this.plugins = {};
    this.element = element;
    this.trigger = this.trigger.bind(this);
    this.frame = this.frame.bind(this);
    this.events = ["pre", "update", "render", "post"].map(function(type) {
      return {type:type};
    });
    if (this.__options.init) {
      this.init();
    }
  }
  init() {
    if (this.__inited) {
      return;
    }
    this.__inited = true;
    this.install(this.__options.plugins);
  }
  destroy() {
    if (!this.__inited) {
      return;
    }
    if (this.__destroyed) {
      return;
    }
    this.__destroyed = true;
    this.trigger({type:"destroy"});
    this.uninstall();
  }
  frame() {
    this.events.map(this.trigger);
  }
  resolve(plugins) {
    plugins = Array.isArray(plugins) ? plugins : [plugins];
    const o = this.__options;
    const aliases = Object.assign({}, o.aliasdb, o.aliases);
    const pred = function(name) {
      const key = name.split(":");
      if (!key[1]) {
        return true;
      }
      aliases[key[0]] = [key[1]];
      return false;
    };
    plugins = plugins.filter(pred);
    Object.entries(aliases).forEach(function([key, alias]) {
      aliases[key] = Array.isArray(alias) ? alias : [alias];
    });
    function recurse(list, out, level) {
      if (level >= 256) {
        throw "Plug-in alias recursion detected.";
      }
      list = list.filter(pred);
      list.forEach(function(name) {
        const alias = aliases[name];
        if (!alias) {
          out.push(name);
        } else {
          out = out.concat(recurse(alias, [], level + 1));
        }
      });
      return out;
    }
    return recurse(plugins, [], 0);
  }
  install(plugins) {
    plugins = Array.isArray(plugins) ? plugins : [plugins];
    plugins = this.resolve(plugins);
    each(plugins, name => this.__install(name));
    this.__ready();
  }
  uninstall(plugins) {
    if (plugins) {
      plugins = Array.isArray(plugins) ? plugins : [plugins];
      plugins = this.resolve(plugins);
    }
    (plugins || this.__installed).reverse().forEach(p => this.__uninstall(p));
  }
  __install(name) {
    const ctor = this.__options.plugindb[name];
    if (!ctor) {
      throw "[three.install] Cannot install. '" + name + "' is not registered.";
    }
    if (this.plugins[name]) {
      return console.warn("[three.install] " + name + " is already installed.");
    }
    const Plugin = ctor;
    const plugin = new Plugin(this.__options[name] || {}, name);
    this.plugins[name] = plugin;
    const flag = plugin.install(this);
    this.__installed.push(plugin);
    this.trigger({type:"install", plugin:plugin});
    return flag;
  }
  __uninstall(name) {
    const plugin = isString(name) ? this.plugins[name] : name;
    if (!plugin) {
      console.warn("[three.uninstall] " + name + "' is not installed.");
      return;
    }
    name = plugin.__name;
    plugin.uninstall(this);
    this.__installed = this.__installed.filter(p => p !== plugin);
    delete this.plugins[name];
    this.trigger({type:"uninstall", plugin:plugin});
  }
  __ready() {
    this.triggerOnce({type:"ready"});
  }
}
Bootstrap.initClass();
Bootstrap.Plugin = function(options) {
  this.options = Object.assign({}, this.defaults, options || {});
};
Bootstrap.Plugin.prototype = {listen:[], defaults:{}, install:function(_three) {
}, uninstall:function(_three) {
},};
require$_DOT__SLASH_binder.Binder.apply(Bootstrap.prototype);
require$_DOT__SLASH_binder.Binder.apply(Bootstrap.Plugin.prototype);
require$_DOT__SLASH_api.Api.apply(Bootstrap.Plugin.prototype);

};